"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = clearCache;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
function clearCache() {
  return _clearCache.apply(this, arguments);
}
function _clearCache() {
  _clearCache = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
    var p,
      _p$clearCachesEnabled,
      clearCachesEnabled,
      clearCachesResolve,
      clearCachesReject,
      cacheNames,
      clearedCaches,
      cleared,
      fail,
      _args = arguments;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          p = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _p$clearCachesEnabled = p.clearCachesEnabled, clearCachesEnabled = _p$clearCachesEnabled === void 0 ? true : _p$clearCachesEnabled, clearCachesResolve = p.clearCachesResolve, clearCachesReject = p.clearCachesReject;
          if (!clearCachesEnabled) {
            _context.next = 25;
            break;
          }
          _context.prev = 3;
          _context.next = 6;
          return caches.keys();
        case 6:
          cacheNames = _context.sent;
          _context.next = 9;
          return Promise.all(cacheNames.map(function (cacheName) {
            return caches["delete"](cacheName);
          }));
        case 9:
          clearedCaches = _context.sent;
          cleared = [];
          fail = [];
          cacheNames.forEach(function (cacheName, i) {
            if (clearedCaches[i]) {
              cleared.push(cacheName);
            } else {
              fail.push(cacheName);
            }
          });
          if (!(cleared.length === cacheNames.length)) {
            _context.next = 17;
            break;
          }
          if (clearCachesResolve) {
            clearCachesResolve({
              cleared: cleared
            });
          }
          _context.next = 19;
          break;
        case 17:
          if (!clearCachesReject) {
            _context.next = 19;
            break;
          }
          return _context.abrupt("return", clearCachesReject({
            err: {
              message: "Clear caches fail: " + fail.join(", ")
            }
          }));
        case 19:
          _context.next = 25;
          break;
        case 21:
          _context.prev = 21;
          _context.t0 = _context["catch"](3);
          if (!clearCachesReject) {
            _context.next = 25;
            break;
          }
          return _context.abrupt("return", clearCachesReject({
            err: _context.t0
          }));
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 21]]);
  }));
  return _clearCache.apply(this, arguments);
}